import axios, {AxiosRequestConfig} from 'axios';


type OptionsType = Exclude<AxiosRequestConfig, 'url, headers'>;

const requiredEnv = (name: 'REACT_APP_API_URL' | 'REACT_APP_SSE_URL'): string => {
    const value = (window as any).env?.[name] || process.env[name];

    if (!value) {
        throw new Error(`Missing required environment variable: ${name}`);
    }

    return value;
}

// Read from window.env (runtime) with fallback to process.env (local dev)
export const baseURL = requiredEnv('REACT_APP_API_URL');
export const sseURL = requiredEnv('REACT_APP_SSE_URL');

export class Api {

    call(url: string, options: OptionsType) {

        const token = localStorage.getItem('auth');

        let authorization = {};

        if (!!localStorage.getItem('auth')) {
            authorization = {'Authorization': `Bearer ${token}`}
        }

        /**
         * @Todo параметры header'a
         * */

        return axios({
            baseURL,
            url,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...authorization
            },
            ...options
        })
    };
}

interface IPagination {
    total:number
    by:number
    page:number
}

export class Pagination implements IPagination{
    total: number;
    by: number;
    page: number;

    constructor(headers:{[key:string]:string}) {
        this.total = +headers['x-pagination-total-count'] || 1;
        this.by = +headers['x-pagination-per-page'] || 1;
        this.page = +headers['x-pagination-page-count'] || 1;
    }

    getData() {
        return{
            total: this.total,
            by: this.by,
            page: this.page
        }
    }
}
